module.exports = __webpack_public_path__ + "img/bg_exclusive-party-areas.9bff532f.jpg";